import { ISubCommittee } from './ISubCommittee.js'

export interface ICommittee {
  chamber: string
  committeeTypeCode: string
  name: string
  parent: null
  subcommittees: ISubCommittee[]
  systemCode: string
  url: string
}
